import { AccomodationEnum } from '../../types/enums/accomodation-type/accomodation-type'
import { JourneyPlaceFilters } from '../../types/models/journey-place/journey-place'

export const transformJourneyPlaceFiltersToUrl = (filters?: JourneyPlaceFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.countryIds && filters.countryIds.length)
    searchParams.append('countryIds', filters.countryIds.join(','))

  if (filters.accomodations && filters.accomodations.length)
    searchParams.append('accomodations', filters.accomodations.join(','))

  return searchParams.toString()
}

export const transformUrlToJourneyPlaceFilters = (
  searchParams: URLSearchParams
): JourneyPlaceFilters => {
  const filters: JourneyPlaceFilters = {}

  const countryIds = searchParams.get('countryIds')
  if (countryIds) filters.countryIds = countryIds.split(',').map((id) => +id)

  const accomodations = searchParams.get('accomodations')
  if (accomodations) filters.accomodations = accomodations.split(',') as AccomodationEnum[]

  return filters
}
